<template>
  <div class="upsells-component">
    <div v-show="isTimerVisible" class="upsells-timer">
      <span v-html="textSpecialOfferValid"></span>:
      <timer-simple-component mins="5" class="d-inline-block" ref="timerComponent" />
    </div>

    <template v-if="activeTab === 'second'">
      <div class="second-step-content">
        <transition name="component-fade" mode="out-in">
          <component
            v-if="upsellsObj.length"
            :is="view"
            @addAccessory="addAccessory"
            @skip="accessoryStep++"
            :discount="(upsellsObj && upsellsObj[getEntity] && upsellsObj[getEntity].discount_percent) || 0"
            :id="(upsellsObj && upsellsObj[getEntity] && upsellsObj[getEntity].product_id) || ''"
            :accessoryStep="accessoryStep"
            :accessoryList="accessoryList"
          />
        </transition>
      </div>
    </template>
    <template v-if="activeTab === 'third'">
      <img :src="logoUrl" class="d-block mx-auto" style="max-width: 250px" alt="" />
      <section class="background--waves">
        <div class="background--waves__second">
          <div class="upsells-component__finish">
            <ProgressBar progress="98" label="4 / 4" />

            <h3 class="original-order mb-1 mt-3">
              <img :src="$root.cdn_url + '/assets/images/upsells/order-icon.svg'" class="mr-1 " />
              {{ textOriginalOrder }}
            </h3>
            <UpsellsItem
              :image-url="product.image[0]"
              :name="product.product_name"
              :subtotal="orderCustomer.productsText[0].price_text"
              :warranty="getOriginalOrder.isWarrantyChecked || getOriginalOrder.warranty ? orderCustomer.productsText[0].warranty_price_text : null"
              :quantity="getOriginalOrder.quantity || getOriginalOrder.deal"
            />
            <template v-if="accessoryList.length">
              <h3 class="accessory-cart mb-1">
                <img :src="$root.cdn_url + '/assets/images/upsells/accessory-icon.svg'" class="mr-1" />
                {{ textAccessoryCart }}
              </h3>
              <UpsellsItem
                @deleteAccessory="deleteAccessory"
                v-for="(it, idx) in accessoryList"
                :image-url="it.imageUrl"
                :idx="idx"
                :id="it.id"
                :key="idx"
                :item-data="it"
                :price="it.price"
                :quantity="it.quantity"
                :final-price="it.finalPrice"
                :withRemoveButton="true"
              />
              <p class="total-price">{{ textTotalAccessoryOrder }}: {{ total }}</p>
              <p v-if="paymentError" id="payment-error" class="error-container" v-html="paymentError"></p>
              <paypal-button v-if="paymentProvider === 'paypal'" class="submit-button" :createOrder="paypalCreateOrder" :onApprove="paypalOnApprove">
                {{ textBuyNow }}
              </paypal-button>
              <StripePayment v-else-if="paymentProvider === 'stripe'" :amount="orderAmount" :upsells="upsellsGrouped" :onSuccess="stripeSuccess" />
              <div v-else @click="submit" class="red-button">
                <Spinner v-if="isSubmitted" />
                <div v-else class="d-flex">
                  <img :src="$root.cdn_url + '/assets/images/upsells/arrow-right.svg'" class="mr-2 ml-sm-5" alt="" />
                  <div class="px-sm-5 w-100">{{ $t("upsells.add_useful_accessories") }}</div>
                </div>
              </div>

              <img :src="$root.cdn_url + '/assets/images/zmc10/partners.png'" class="partners mx-auto w-100 my-4 d-block" />

              <div class="package-text d-flex text-center mx-sm-5">
                <img :src="$root.cdn_url + '/assets/images/upsells/leaf.svg'" alt="" />
                <div class="pl-1">{{ textShipmentPackage }}</div>
              </div>
            </template>
          </div>
        </div>
      </section>
    </template>
  </div>
</template>

<script>
import wait from "../utils/wait";
import { t } from "../utils/i18n";
import UpsellsItem from "./common/UpsellsItem";
import StepWarranty from "./upsells/StepWarranty";
import StepPlusOne from "./upsells/StepPlusOne";
import Step1 from "./upsells/Step1";
import Step2 from "./upsells/Step2";
import Step3 from "./upsells/Step3";
import { fade } from "../utils/common";
import { goTo } from "../utils/goTo";
import { groupBy } from "../utils/groupBy";
import { send1ClickRequest, paypalCreateOrder, paypalOnApprove } from "../utils/upsells";
import upsellsMixin from "../mixins/upsells";
import { getTotalPrice } from "../services/upsells";
import logger from "../mixins/logger";
import upsells from "../mixins/upsells";
import Spinner from "./common/preloaders/Spinner.vue";
import ProgressBar from "./upsells/ProgressBar";
import StripePayment from "./common/StripePayment";

export default {
  name: "upsells",
  mixins: [upsellsMixin, logger, upsells],

  components: {
    UpsellsItem,
    StepWarranty,
    StepPlusOne,
    Step1,
    Step2,
    Step3,
    Spinner,
    ProgressBar,
    StripePayment
  },

  data() {
    return {
      total: 0,
      view: "StepWarranty",
      activeTab: "second",
      accessoryStep: -1, // by default we have extra step (-1) for warranty
      accessoryList: [
        // uncomment static warranty data for cart testing
        // { id: 'warranty', name: "Warranty", price: 100, imageUrl: this.$root.cdn_url + "/assets/images/upsells/warranty-picture.png" }, { id: '123', name: "Some product", price: 220, imageUrl: this.$root.cdn_url + "/assets/images/upsells/warranty-picture.png" }
      ],
      product: js_data.product,
      upsellsObj: js_data.product.upsells,
      orderCustomer: js_data.order_customer,
      upsellsAsProdsList: [],
      paymentError: "",
      isSubmitted: false,
      isLoading: false,
      isTimerVisible: false,
      orderAmount: 0 // total amount in cents used for Stripe payments
    };
  },

  beforeCreate() {
    window.serverData = {};

    localStorage.removeItem("subOrder");

    if (js_data.product.upsells.length === 0 || (window.performance && performance.navigation && performance.navigation.type == 1)) {
      // DISABLED FOR DEBUG ONLY
      // http://127.0.0.1:11111/thankyou-promos?order=6099086097309e15c22bdc60&cur=USD&qty=1&tpl=zmc10#
      // return goTo('/thankyou');
    }

    wait(
      () => document.readyState === "complete",
      () => setTimeout(() => (window.location = "#"), 500)
    );
  },

  created() {
    // check if user ordered warranty and warranty available
    // const quantity = js_data.order_customer.products[0].quantity;
    const isWarrantyPurchased = js_data.order_customer.products[0].warranty_price > 0;

    // skip to next step
    if (isWarrantyPurchased || js_data.product.is_hygiene) {
      this.view = "StepPlusOne";
      this.accessoryStep = 0;
    }
  },

  mounted() {
    // hide footer for first steps
    document.querySelector("footer.footer-region").style.display = "none";
  },

  watch: {
    accessoryStep(val) {
      if (val === this.upsellsObj.length || this.getAllowedUpsellQty() === 0) {
        const node = document.querySelector(".second-step-content");
        fade("out", 250, node, true).then(() => {
          if (this.accessoryList.length !== 0) {
            if (!this.totalAccessoryPrice) {
              this.log_data("UPSELLS: total=0 - watch", {
                force: true,
                url: location.href,
                accessoryStep: val,
                serverData: window.serverData,
                subOrder: localStorage.getItem("subOrder"),
                totalAccessoryPrice: this.totalAccessoryPrice,
                formattedAccessoryList: this.formattedAccessoryList,
                accessoryList: this.accessoryList,
                upsellsObj: this.upsellsObj,
                ua: navigator.userAgent
              });
            }

            this.hideTimer();

            getTotalPrice(this.formattedAccessoryList, this.totalAccessoryPrice)
              .then(total => {
                this.total = total.value_text;
                this.orderAmount = Math.round(total.value * 100);
                this.activeTab = "third";
              })
              .catch(() => {
                this.activeTab = "third";
              });
          } else {
            this.redirect();
          }

          setTimeout(() => fade("in", 250, node, true));
        });
      }

      // this.view = "Step2"; return; // force specific template for testing
      // define what template show next
      if (val === 0) {
        this.view = "StepPlusOne";
      } else if (val % 2 == 1) {
        this.view = "Step1";
        // show footer from this step
        document.querySelector("footer.footer-region").style.display = "block";
      } else {
        this.view = "Step2";
      }

      // reset timer
      if (this.view !== "StepPlusOne") {
        this.showTimer();
      }
    }
  },

  computed: {
    formattedAccessoryList() {
      return this.accessoryList.map(({ quantity, id }) => ({
        quantity,
        id
      }));
    },

    textFirstStep: () => t("upsells.step_1.title.short"),
    textSecondStep: () => t("upsells.step_2.title.short"),
    textThirdStep: () => t("upsells.step_3.title.short"),
    textCancel: () => t("upsells.cancel.full"),
    textOriginalOrder: () => t("upsells.original_order"),
    textAccessoryCart: () => t("upsells.accessory_cart"),
    textTotalAccessoryOrder: () => t("upsells.accessory_order"),
    textBuyNow: () => t("upsells.paypal_button_text"),
    textBuyAccessories: () => t("upsells.step_3.buy_accessories"),
    textPaymentError: () => t("upsells.step_3.payment_error"),
    textShipmentPackage: () => t("upsells.shipment_package"),
    textSpecialOfferValid: () => t("upsells.offer_valid"),

    getEntity() {
      if (this.accessoryStep > this.upsellsObj.length) {
        return this.upsellsObj.length;
      } else {
        return this.accessoryStep;
      }
    },

    getOriginalOrder() {
      let selectedProductData = {};

      try {
        const data = localStorage.getItem("selectedProductData") || localStorage.getItem("saved_form");
        selectedProductData = JSON.parse(data) || {};
      } catch (err) {}

      return selectedProductData;
    },

    getOriginalOrderPrice() {
      const deal = this.getOriginalOrder.quantity || this.getOriginalOrder.deal || 1;
      return js_data.product.prices[deal].value;
    },

    getOriginalOrderId() {
      return localStorage.getItem("odin_order_id");
    },

    totalAccessoryPrice() {
      return this.accessoryList.map(it => it.finalPricePure).reduce((acc, item) => acc + item, 0);
    },

    paymentProvider() {
      return this.getOriginalOrder.paymentProvider || this.getOriginalOrder.payment_provider;
    },

    upsellsGrouped() {
      return this.accessoryList.map(upsell => ({
        id: upsell.id,
        qty: upsell.quantity
      }));
      //return groupBy(this.accessoryList, "id", "quantity");
    },

    logoUrl() {
      return js_data.product.logo_image;
    }
  },

  methods: {
    submit() {
      if (this.isSubmitted) {
        return;
      }

      this.paymentError = "";
      this.isSubmitted = true;

      const data = {
        order: this.getOriginalOrderId,
        upsells: this.accessoryList.map(upsell => ({
          id: upsell.id,
          qty: upsell.quantity
        }))
      };

      send1ClickRequest(data, this.accessoryList, this.paymentProvider).then(res => {
        if (res.paymentError) {
          this.paymentError = res.paymentError;
          this.isSubmitted = false;
        }
      });
    },

    paypalCreateOrder() {
      return paypalCreateOrder({
        xsrfToken: document.head.querySelector('meta[name="csrf-token"]').content,
        sku_code: this.getOriginalOrder.variant,
        sku_quantity: this.getOriginalOrder.quantity || this.getOriginalOrder.deal,
        is_warranty_checked: false,
        order: this.getOriginalOrderId,
        page_checkout: document.location.href,
        offer: js_query_params.offer || null,
        affiliate: js_query_params.affiliate || null,
        upsells: groupBy(this.accessoryList, "id", "quantity"),
      });
    },

    paypalOnApprove: paypalOnApprove,

    stripeSuccess() {
      localStorage.setItem("odin_order_created_at", new Date());
      goTo("/thankyou");
    },

    addAccessory(accessory) {
      this.accessoryStep++;
      this.accessoryList.push(accessory);
    },

    deleteAccessory(indexForDeleting) {
      this.accessoryList.splice(indexForDeleting, 1);

      if (this.accessoryList.length === 0) {
        this.redirect();
        return;
      }

      if (!this.totalAccessoryPrice) {
        this.log_data("UPSELLS: total=0 - delete", {
          force: true,
          url: location.href,
          serverData: window.serverData,
          subOrder: localStorage.getItem("subOrder"),
          totalAccessoryPrice: this.totalAccessoryPrice,
          formattedAccessoryList: this.formattedAccessoryList,
          accessoryList: this.accessoryList,
          upsellsObj: this.upsellsObj,
          ua: navigator.userAgent
        });
      }

      getTotalPrice(this.formattedAccessoryList, this.totalAccessoryPrice).then(total => {
        this.total = total.value_text;
      });
    },

    redirect() {
      goTo(`/thankyou/?`);
    },

    showTimer() {
      // we need to add gap to root element
      document.getElementById("app").style.paddingTop = "46px";
      this.isTimerVisible = true;
      this.$refs.timerComponent.reset();
    },

    hideTimer() {
      this.isTimerVisible = false;
      document.getElementById("app").style.paddingTop = "0";
    }
  }
};
</script>

<style lang="scss">
main.pt-4 {
  padding: 0 !important;
}

.upsells-component {
  font-family: Roboto, Arial, Helvetica, sans-serif;

  .container {
    max-width: 924px;

    &--lg {
      max-width: 1100px;
    }

    &--md {
      max-width: 747px;
    }
  }

  section.background-gray {
    background-color: #f5f9fa;
  }

  section.background-gradient {
    background: linear-gradient(225.34deg, #ffffff 0%, #ccdeff 101.17%);
    // box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.25);
  }

  .background--waves {
    background: #f5f9fa;
    box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.25);
    background-image: url("/assets/images/upsells/bg-wave-1.svg");
    background-size: 100%;
    background-repeat: no-repeat;
    background-position-y: top;
    margin: 10px 0 50px;

    &__second {
      background-image: url("/assets/images/upsells/bg-wave-2.svg");
      background-size: 100%;
      background-repeat: no-repeat;
      background-position-y: top;
      padding: 50px 0;
    }
  }

  .upsells-timer {
    position: fixed;
    top: 0;
    width: 100%;
    background-color: #ffc439;
    padding: 11px;
    text-align: center;
    font-weight: bold;
    font-size: 24px;
    line-height: 25px;
    color: #333333;
    z-index: 15;
  }

  // customize loading spinner
  .spinner div:after {
    background-color: #f75353;
  }

  &__top {
    border-radius: 3px;
    max-width: 719px;
    overflow: hidden;
  }

  &__step {
    text-transform: uppercase;
    color: white;
    font-size: 17px;
    line-height: 27px;
    text-align: center;
    background-color: #0089cc;
    flex-grow: 1;
    padding: 3px;

    &:nth-child(2) {
      background-color: #026190;
    }

    &:nth-child(3) {
      background-color: #001326;
    }

    &.active {
      font-weight: bold;
    }
  }

  &__content {
    .green-up {
      color: #0d840d;
    }

    h4 {
      font-size: 20px;
      text-align: center;

      .congrats {
        color: #d4513a;
      }
    }

    h5 {
      font-size: 25px;
      text-align: center;
      margin-top: 0;
    }
  }

  &__item {
    display: flex;

    .benefits {
      list-style-type: none;
      width: 60%;
      font-size: 20px;
      flex-grow: 1;

      li {
        margin-bottom: 2px;
      }
    }

    .image {
      margin-left: 15px;
      max-width: 300px;

      [dir="rtl"] & {
        margin-left: 0;
        margin-right: 15px;
      }

      img {
        max-width: 150px;
        width: 100%;
        height: auto;
      }
    }
  }

  &__bot {
    margin-top: 20px;
    display: flex;
    justify-content: space-between;

    .green-button-animated {
      max-width: 350px;
      width: 100%;
      height: auto;
    }
  }

  .no {
    margin-top: 20px;
    text-align: center;

    a {
      cursor: pointer;
      font-size: 18px;
      line-height: 30px;
      color: #626262;
      text-decoration: underline;
    }
  }

  &__finish {
    max-width: 820px;
    margin: 30px auto;
    box-shadow: 0px 0px 7px rgba(0, 0, 0, 0.5);
    padding: 30px;
    background-color: #fff;

    // override default button styles
    .green-button-animated {
      background: #0f9b0f;
      padding: 20px 94px;
      height: auto !important;

      .green-button-text {
        font-size: 21px;
        line-height: 25px;
        text-shadow: none;
      }
    }

    h3 {
      font-size: 24px;
      line-height: 20px;
    }

    .partners {
      max-width: 396px;
    }

    .package-text {
      font-size: 18px;
      line-height: 30px;
      color: #333333;
    }

    .original-order {
      text-align: left;
      margin-bottom: 0;
    }

    .upsells-item {
      margin-bottom: 15px;
    }

    .total-price {
      text-align: right;
      margin: 30px 0;
    }

    .buy-block {
      display: flex;
      justify-content: center;

      .buy-button {
        height: 60px;
        width: 100%;
        max-width: 780px;
      }
    }
  }

  #payment-error {
    font-size: 17px;
    text-align: center;
  }

  .submit-button {
    margin-left: auto;
    margin-right: auto;
    max-width: 670px;

    &.green-button-animated {
      font-size: 26px;
      height: 79px;
    }
  }

  .red-button {
    background: linear-gradient(180deg, #f0c14b 0%, rgba(240, 193, 75, 0.9) 49.3%, rgba(240, 193, 75, 0.6) 100%);
    border: 1px solid #846a29;
    box-sizing: border-box;
    border-radius: 3px;
    padding: 23px 15px;
    font-weight: 500;
    font-size: 20px;
    line-height: 23px;
    text-align: center;
    text-transform: capitalize;

    color: #0c0c0c;
    text-align: center;
    cursor: pointer;

    &:hover {
      box-shadow: 0px 0px 35px #b1b1b1;
    }
  }

  // for responsive video embeding
  .embed-container {
    position: relative;
    padding-bottom: 56.25%;
    height: 0;
    overflow: hidden;
    max-width: 100%;

    iframe,
    object,
    embed,
    video {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }
  }

  .amount-selector {
    &__title {
      font-weight: bold;
      font-size: 20px;
      line-height: 24px;
      color: #333333;
    }

    &__discount {
      font-size: 14px;
      line-height: 16px;
      color: #ffffff;
      background: #0089cc;
      border-radius: 2px;
      padding: 8px 6px;
      display: inline-block;
    }

    &__price {
      font-weight: 500;
      font-size: 20px;
      line-height: 24px;
      color: #333333;
      display: inline-block;
    }
  }

  @media screen and (max-width: 767px) {
    section.background-gray {
      background-color: transparent;
    }

    .container {
      padding-left: 8px;
      padding-right: 8px;
    }

    .background--waves,
    .background--waves__second {
      margin: 0;
      padding: 0;
      box-shadow: none;
      background: transparent;
    }

    .upsells-timer {
      font-size: 20px;
      line-height: 25px;
      span > span {
        display: none;
      }
    }

    &__item {
      flex-direction: column-reverse;

      .benefits {
        width: 100%;
      }

      .image {
        width: 100%;
        max-width: none;
        margin-left: 0;
        padding: 20px 30px;
        text-align: center;

        img {
          max-width: 100%;
          width: 70%;
        }
      }
    }

    &__finish {
      margin: 0;
      box-shadow: none;

      // override default button styles
      .green-button-animated {
        padding: 20px 30px;
      }

      .package-text {
        font-size: 16px;
        line-height: 30px;
      }
    }

    .red-button {
      border-radius: 3px;
      font-size: 20px;
      line-height: 26px;
    }

    .no {
      a {
        font-size: 16px;
        line-height: 30px;
      }
    }
  }

  @media screen and (max-width: 992px) {
    &__content {
      padding: 5px;
    }
  }
}
</style>
